export default __webpack_public_path__ + "static/media/pen-and-paper.0f46e272.png";